export default "__VITE_ASSET__AEiPy2il__"